module.exports = __webpack_public_path__ + "img/hr.e34d858.webp";